"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var ReplenishmentPromoManagementUpdateDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReplenishmentPromoManagementUpdateDTOConverter, _DataObjectConverter_);

  function ReplenishmentPromoManagementUpdateDTOConverter() {
    _classCallCheck(this, ReplenishmentPromoManagementUpdateDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementUpdateDTOConverter).apply(this, arguments));
  }

  return ReplenishmentPromoManagementUpdateDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReplenishmentPromoManagementUpdateDTOConverter = ReplenishmentPromoManagementUpdateDTOConverter;